import React, { useEffect, useState } from "react";
import { Sparkles, X } from "lucide-react";

const FloatingCtaModule = () => {
  const [isVisible, setIsVisible] = useState(true);
  const [isDismissed, setIsDismissed] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsVisible(window.scrollY <= 200);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  if (!isVisible || isDismissed) {
    return null;
  }

  return (
    <div className="rounded-md border border-purple-100 bg-white p-4 shadow-sm">
      <button
        type="button"
        className="float-right rounded-sm p-1 text-gray-400 transition hover:bg-slate-50 hover:text-gray-700"
        aria-label="Close promotion"
        onClick={() => setIsDismissed(true)}
      >
        <X className="h-4 w-4" aria-hidden="true" />
      </button>
      <div className="flex gap-3">
        <span className="grid h-10 w-10 shrink-0 place-items-center rounded-sm bg-[rgba(126,34,206,0.08)] text-[rgb(126,34,206)]">
          <Sparkles className="h-5 w-5" aria-hidden="true" />
        </span>
        <div>
          <h5 className="font-extrabold text-gray-900">Choose PrepNexis</h5>
          <p className="mt-1 text-sm leading-6 text-gray-500">
            Start your free trial and explore smarter PTE preparation.
          </p>
          <a
            className="mt-3 inline-flex items-center gap-2 rounded-sm bg-[rgba(126,34,206,0.08)] px-3 py-2 text-sm font-semibold text-[rgb(126,34,206)] ring-1 ring-[rgba(126,34,206,0.16)] transition hover:bg-[rgba(126,34,206,0.12)]"
            href="/signup"
          >
            <Sparkles className="h-4 w-4" aria-hidden="true" />
            Get Free Trial
          </a>
        </div>
      </div>
    </div>
  );
};

export default FloatingCtaModule;
